import { render } from "./FooterMoovePage.vue?vue&type=template&id=373e8b87&scoped=true"
import script from "./FooterMoovePage.vue?vue&type=script&lang=js"
export * from "./FooterMoovePage.vue?vue&type=script&lang=js"

import "./FooterMoovePage.vue?vue&type=style&index=0&id=373e8b87&scoped=true&lang=css"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373e8b87"]])

export default __exports__